import React, { useState } from 'react';
import './OtherProjects.css';

const otherProjectsData = [
  {
    title: 'PharmaSave Poster',
    description: 'Project for finals.',
    toolsUsed: 'Tool Used: Canva',
    images: ['https://i.imgur.com/olK5vdY.jpeg']
  },
  {
    title: "Intern ID's",
    description: 'Personally designed an ID for the interns of the company.',
    toolsUsed: 'Tool Used: Photoshop',
    images: [
      'https://i.imgur.com/3bGS52h.png',
      'https://i.imgur.com/xrqkdi2.png',
      'https://i.imgur.com/yjutPfM.png',
      'https://i.imgur.com/4Kp938R.png',
      'https://i.imgur.com/1grE0G9.png',
    ]
  },
  {
    title: 'Idea Pins',
    description: 'Task for marketing interns.',
    toolsUsed: 'Tool Used: Photoshop',
    images: [
      'https://i.imgur.com/jnquYi4.png',
      'https://i.imgur.com/iMRyDHs.png',
      'https://i.imgur.com/Enodpz4.png',
      'https://i.imgur.com/Uy5nuW9.png',
      'https://i.imgur.com/OoRMFZE.png',
    ]
  },
  {
    title: 'Banner ',
    description: 'Finals project for the marketing department.',
    toolsUsed: 'Tool Used: Photoshop',
    images: ['https://i.imgur.com/Ko1M1Cx.png']
  }
];


function OtherProjects() {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeProject, setActiveProject] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (projectIndex) => {
    setActiveProject(projectIndex);
    setCurrentImageIndex(0);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveProject(null);
  };

  const nextImage = () => {
    const images = otherProjectsData[activeProject].images;
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    const images = otherProjectsData[activeProject].images;
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <section id="otherprojects" className="other-projects-section">
      <div className="ttl">
        <h1>Other Projects</h1>
      </div>
      <div className="other-projects-grid">
        {otherProjectsData.map((project, index) => (
          <div className="other-project-card" key={index} onClick={() => openModal(index)}>
            <img src={project.images[0]} alt={project.title} />
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <p>{project.toolsUsed}</p>
          </div>
        ))}
      </div>

      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>X</button>
            <img
              className="modal-image"
              src={otherProjectsData[activeProject].images[currentImageIndex]}
              alt="Enlarged"
            />
            {otherProjectsData[activeProject].images.length > 1 && (
              <div className="modal-nav">
                <button className="nav-arrow" onClick={prevImage}>❮</button>
                <button className="nav-arrow" onClick={nextImage}>❯</button>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default OtherProjects;
